/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Partner_Billing_Board_Next_RunInputs */



/**
* | output |
* | --- |
* | "Invoices are created automatically · next run {when}" |
*
* @param {Partner_Billing_Board_Next_RunInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_next_run = /** @type {((inputs: Partner_Billing_Board_Next_RunInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Next_RunInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Rechnungen werden automatisch erstellt · nächster Lauf ${i?.when}`)
	return /** @type {LocalizedString} */ (`Invoices are created automatically · next run ${i?.when}`)
});